"use client";
import React from "react";
import MentorCard from "./ui/MentorCard";
import { useGetMentors } from "@/actions/mentor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

const MentorsSection: React.FC = () => {
  const { mentors, mentorsLoading, mentorsEmpty } = useGetMentors();

  if (mentorsEmpty) {
    return null;
  }

  return (
    <section className="pb-20 px-4">
      <div className="max-w-352 mx-auto">
        <h2 className="font-red-hat text-[30px] sm:text-[40px] font-light leading-10 sm:leading-13.25 text-[#1B515E] text-center mb-10 sm:mb-14.5">
          Les mentors experts chez Spot Formations
        </h2>

        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          spaceBetween={10}
          slidesPerView="auto"
          className="mentors-swiper pb-12!"
        >
          {mentorsLoading
            ? Array.from({ length: 4 }).map((_, i) => (
                <SwiperSlide key={i} className="w-85!">
                  <div className="h-96 bg-gray-100 animate-pulse rounded-3xl" />
                </SwiperSlide>
              ))
            : mentors.map((mentor) => (
                <SwiperSlide key={mentor.id} className="w-86!">
                  <MentorCard
                    name={mentor.name}
                    role={mentor.role ?? ""}
                    bio={mentor.bio ?? ""}
                    formationsCount={mentor.formations_count}
                    tags={mentor.tags}
                    image={mentor.image ?? "/assets/photos-profil.png"}
                  />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </section>
  );
};

export default MentorsSection;
